import { gql } from '@apollo/client';
import { getExplorerAPIClient } from 'common/lib/apolloExplorerAPIClient';

export async function deleteAPIKey(params: {
  keyId: string;
  jwt: string;
}): Promise<boolean> {
  const client = getExplorerAPIClient();
  const apiResult = await client.mutate({
    variables: {
      deleteAPIKeyInput: params
    },
    mutation: gql`
      mutation DeleteAPIKey($deleteAPIKeyInput: DeleteAPIKeyInput) {
        deleteAPIKey(input: $deleteAPIKeyInput)
      }
    `
  });
  return apiResult.data.deleteAPIKey;
}
